import { render, staticRenderFns } from "./grip.vue?vue&type=template&id=70874395&scoped=true&"
import script from "./grip.vue?vue&type=script&lang=js&"
export * from "./grip.vue?vue&type=script&lang=js&"
import style0 from "./grip.vue?vue&type=style&index=0&id=70874395&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70874395",
  null
  
)

export default component.exports